import type { ComposeTab } from '../composeActions';

/**
 * Mermaid diagram templates — each inserts a starter ```mermaid fence
 * for the operator to fill in. kind:'insert' so the user can edit
 * before sending.
 */
const flowTemplate =
  '```mermaid\nflowchart TD\n    A[Start] --> B{Decision}\n    B -->|Yes| C[Process]\n'
  + '    B -->|No| D[Alternative]\n    C --> E[End]\n    D --> E\n```\n';

const seqTemplate =
  '```mermaid\nsequenceDiagram\n    actor User\n    participant System\n'
  + '    User->>System: Request\n    System-->>User: Response\n```\n';

const classTemplate =
  '```mermaid\nclassDiagram\n    class Entity {\n        +String name\n'
  + '        +method()\n    }\n```\n';

const erTemplate =
  '```mermaid\nerDiagram\n    ENTITY_A ||--o{ ENTITY_B : "relates"\n'
  + '    ENTITY_B ||--|{ ENTITY_C : "contains"\n```\n';

const stateTemplate =
  '```mermaid\nstateDiagram-v2\n    [*] --> Idle\n    Idle --> Active: trigger\n'
  + '    Active --> Done: complete\n    Done --> [*]\n```\n';

export const diagramsTab: ComposeTab = {
  id: 'diagrams',
  emoji: '🎨',
  label: 'Diagrams',
  descriptor: 'Mermaid template starters — insert + edit + send',
  actions: [
    { kind: 'insert', id: 'diagram-flow',  label: '🔀 Flow',     prompt: flowTemplate,  descriptor: 'Decision tree / flowchart' },
    { kind: 'insert', id: 'diagram-seq',   label: '📨 Sequence', prompt: seqTemplate,   descriptor: 'Actor-system message exchange' },
    { kind: 'insert', id: 'diagram-class', label: '📦 Class',    prompt: classTemplate, descriptor: 'OO class diagram' },
    { kind: 'insert', id: 'diagram-er',    label: '🗃 ER',       prompt: erTemplate,    descriptor: 'Entity-relationship' },
    { kind: 'insert', id: 'diagram-state', label: '🔄 State',    prompt: stateTemplate, descriptor: 'State machine v2' },
  ],
};
